import React from "react";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { fetchApi } from "../../../helper/api";
import { IsAlert } from "../../atoms/IsAlert";
import { useNavigate } from "react-router-dom";
import { deleteAllCookies } from "../../../helper/function";

const ChangePassword = () => {
  const navigate = useNavigate();
  const [values, setValues] = React.useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
    showPassword: false,
    error: null
  });

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value });
  };

  const handleClickShowPassword = () => {
    setValues({
      ...values,
      showPassword: !values.showPassword,
    });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleUpdatePassword = async () => {
    console.log("Value : ", values);
    if (values.newPassword === values.confirmPassword) {
      setValues({ ...values, error: null });
      // fetch update
      const dataPost = {
        newPassword: values.newPassword,
        oldPassword: values.oldPassword
      };
      const req = await fetchApi(
        "api/User/updatePasswordNoToken",
        "PUT",
        true,
        dataPost
      );
      const status = req.status;
      const res = await req.json();
      if (status === 200) {
        IsAlert.fire({
          title: res.status,
          text: res.message,
          icon: "success",
          showCancelButton: false,
          focusConfirm: true,
          confirmButtonText: "OK",
        }).then(function (isConfirm) {
          if (isConfirm.isConfirmed) {
            deleteAllCookies();
            navigate("/login");
            window.location.reload();
          }
        });
      } else {
        setValues({
          ...values,
          error: res.message,
        });
      }
    } else {
      console.log("Confirm", values.newPassword === values.confirmPassword);
      setValues({ ...values, error: "Konfirmasi password tidak sama!" });
    }
  };

  return (
    <div
      className="modal fade"
      id="exampleModal"
      tabIndex={-1}
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center">
              <i className="las la-user-lock" style={{ fontSize: 22 }} />
              <h5 className="mb-0 ml-2">Change Password</h5>
            </div>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="py-2">
              <FormControl className="w-100" variant="outlined">
                <InputLabel htmlFor="old_pass">Old Password</InputLabel>
                <OutlinedInput
                  className="w-100"
                  id="old_pass"
                  type={values.showPassword ? "text" : "password"}
                  value={values.oldPassword}
                  onChange={handleChange("oldPassword")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
            </div>
            <div className="py-2">
              <FormControl className="w-100" variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  New Password
                </InputLabel>
                <OutlinedInput
                  className="w-100"
                  id="outlined-adornment-password"
                  type={values.showPassword ? "text" : "password"}
                  value={values.newPassword}
                  onChange={handleChange("newPassword")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
            </div>
            <div className="py-2">
              <FormControl className="w-100" variant="outlined">
                <InputLabel htmlFor="outlined-adornment-confirm-password">
                  Confirm Password
                </InputLabel>
                <OutlinedInput
                  className="w-100"
                  id="outlined-adornment-confirm-password"
                  type={values.showPassword ? "text" : "password"}
                  value={values.confirmPassword}
                  onChange={handleChange("confirmPassword")}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {values.showPassword ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Password"
                />
              </FormControl>
              {values.error && (
                <span className="text-danger">
                  {values.error}
                </span>
              )}
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-light"
              data-dismiss="modal"
            >
              Close
            </button>
            <button type="button" onClick={() => handleUpdatePassword()} className="btn btn-primary">
              Save changes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ChangePassword;
